import API from '@/api';

class MissionApplication
{
  /**
   * Do api call to cancel an application
   *
   * @return {promise}
   */
  static async cancelApplication(params) {
    return await API.dispatch(
      'PATCH',
      'cancelApplication',
      params,
      {
        'Content-Type': 'application/json'
      }
    );
  }
}

export default MissionApplication;
